import React, {useEffect, useState} from "react";
import {
    IonPage,
    IonContent, IonLoading, IonRefresher, IonRefresherContent
} from "@ionic/react";
import {
    actionToGetOtherUsersMatrimonialProfileData,
    actionToGetUserMatrimonialProfileData,
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "./Loader/FacebookLoader";
import MatrimonyProfileCard from "./MatrimonyProfileCard";
import MatrimonialDetailSheetPopup from "./MatrimonialDetailSheetPopup";
import AddMatrimonialCandidateProfileModal from "./AddMatrimonialCandidateProfileModal";
import MatrimonialRoleBasedDataMobile from "./MatrimonialRoleBasedDataMobile";

export default function MatrimonialMobileDashboardPage({renderHeaderPage,isMobile}) {
    const [isOpenMainListPanel,setIsOpenMainListPanel] = useState(false);
    const [myPostsData,setMyPostsData] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const [matrimonialProfileAddModal,setMatrimonialProfileAddModal] = useState(false);
    const [dataForEditing,setDataForEditing] = useState(null);
    const {
        userMatrimonialProfileData,otherUsersMatrimonialProfileData,
        setMatrimonialProfileDetail,matrimonialProfileDetail,
        isMatrimonialDetailOpen,setIsMatrimonialDetailOpen
    }= useStore();

    const openMainMatrimonialListPanel = (myPosts)=>{
        setMyPostsData(myPosts);
        setIsOpenMainListPanel(true);
    }

    useEffect(() => {
        actionToGetUserMatrimonialProfileData();
        actionToGetOtherUsersMatrimonialProfileData();
    }, []);

    const callFunctionToSetEditData = (data)=>{
        setDataForEditing(data);
        setMatrimonialProfileAddModal(true);
    }

    const handleRefresh = (event) => {
        actionToGetUserMatrimonialProfileData();
        actionToGetOtherUsersMatrimonialProfileData();
        setTimeout(() => {
            event.detail.complete();
        }, 2000);
    };

    const openMatrimonialProfileDetailPanel = (detail)=>{
        setMatrimonialProfileDetail(detail);
        setIsMatrimonialDetailOpen(true);
    }

    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="looking-for-page page-content">
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent pullingText="Pull to refresh" refreshingSpinner="circles"/>
                </IonRefresher>
                <div className={"main_inner_container_common_page mobile_inner_dashboard_page job_mob_d"}>
                    {(userMatrimonialProfileData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    My Profile
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(userMatrimonialProfileData?.matrimonialProfileData?.length) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Profile
                                    </div>
                                    <div onClick={()=>callFunctionToSetEditData(userMatrimonialProfileData?.matrimonialProfileData[0])} className={"view_all_action_button"}>
                                        Edit
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    {(userMatrimonialProfileData?.matrimonialProfileData?.map((profile)=>(
                                        <MatrimonyProfileCard
                                            profile={profile}
                                            key={profile.id}
                                            handleProfileItemClick={openMatrimonialProfileDetailPanel}
                                        />
                                    )))}
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        My Profile
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>

                                </div>
                            </div>
                    }

                    {/*///////////// ALL POST DATA //////////////////*/}
                    {(otherUsersMatrimonialProfileData?.loading) ?
                        <div className={"verticel_scroll_container_outer"}>
                            <div className={"h_in_v_card"}>
                                <div className={"in_heading"}>
                                    Other Users Profile
                                </div>
                            </div>
                            <div className={"verticel_scroll_container_inner"}>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                                <div className="job-card">
                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                </div>
                            </div>
                        </div>
                        :(otherUsersMatrimonialProfileData?.matrimonialProfileData?.length) ?
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Users Profile
                                    </div>
                                    <div onClick={()=>openMainMatrimonialListPanel(false)} className={"view_all_action_button"}>
                                        View All
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    {(otherUsersMatrimonialProfileData?.matrimonialProfileData?.map((profile)=>(
                                        <MatrimonyProfileCard
                                            profile={profile}
                                            key={profile.id}
                                            handleProfileItemClick={openMatrimonialProfileDetailPanel}
                                        />
                                    )))}
                                </div>
                            </div>
                            :
                            <div className={"verticel_scroll_container_outer"}>
                                <div className={"h_in_v_card"}>
                                    <div className={"in_heading"}>
                                        Other Users Profile
                                    </div>
                                </div>
                                <div className={"verticel_scroll_container_inner"}>
                                    <div className={"no_data_found_add_new_data job-card my-job-profile"}>
                                        <div className={"message_no_j_d_but"}>
                                            No Matrimonial Posted Yet!
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                    {/*///////////// ALL POST DATA //////////////////*/}
                </div>
            </IonContent>

            {(isOpenMainListPanel) ?
            <MatrimonialRoleBasedDataMobile
                isOpen={isOpenMainListPanel}
                myPostsData={myPostsData}
                setMatrimonialProfileDetail={setMatrimonialProfileDetail}
                matrimonialProfileDetail={matrimonialProfileDetail}
                onDidDismiss={() => setIsOpenMainListPanel(false)}
            />:''
            }

            {(isMatrimonialDetailOpen) ?
            <MatrimonialDetailSheetPopup
                isOpen={isMatrimonialDetailOpen}
                isMobile={isMobile}
                onDidDismiss={() => setIsMatrimonialDetailOpen(false)}
                matrimonialProfileDetail={matrimonialProfileDetail}/>
                :''
            }


            {(matrimonialProfileAddModal) ?
            <AddMatrimonialCandidateProfileModal isOpen={matrimonialProfileAddModal}
                                                 dataForEditing={dataForEditing}
                                                 onClose={() => setMatrimonialProfileAddModal(false)}
                                                 setIsLoading={setIsLoading}/>
                :''
            }

            <IonLoading isOpen={isLoading} className={"loading_loader_spinner_container"} message={"Please Wait..."}/>
        </IonPage>
    )
}
